<template>
<div class='vx-col w-full'>
    <div class="botonera-navegacion-juego" v-if="codigo_creado">
        <!-- <vs-button class="m-2" :type="op_show == 1 ? 'filled' : 'border'" color="dark" @click="op_show=1">Cabecera</vs-button>
        <vs-button class="m-2" :type="op_show == 2 ? 'filled' : 'border'" color="primary" @click="op_show=2">Opciones</vs-button>
        <vs-button class="m-2" :type="op_show == 3 ? 'filled' : 'border'" color="success" @click="op_show=3">Previsualizar</vs-button> -->
        <Botonera @getClicked_botonera="getClicked_botonera" :botonera_juego="botonera_juego"/>
    </div>
    <div class="cabecera-juego" v-if="op_show==1">
        <!-- datos_tipo_juego_select ADMIN COLUMNAS {{ datos_tipo_juego_select }} -->
        <transition name="fade" mode="out-in">
            <CabeceraJuego v-if="op_cargar" @getCodigo="getCodigo" :datos_editar="datos_editar_columnas" :tipo_accion="tipo_accion" :datos_tipo_juego_select="datos_tipo_juego_select" />
        </transition>
    </div>
    <div class="opciones" v-if="op_show==2">
        <transition name="fade" mode="out-in">
            <Opciones_columnas v-if="codigo_creado" :datos_editar="datos_editar_columnas" />
        </transition>
    </div>
    <div class="game-columnas" v-if="op_show==3">
        <transition name="fade" mode="out-in">
            <GameColumnas v-if="codigo_creado" :datos_editar="datos_editar_columnas" />
        </transition>
    </div>
</div>
</template>

<script>
import CabeceraJuego from '../cabeceraJuego.vue';
import GeneralMixin from '@/mixins/GeneralMixin';
import Opciones_columnas from './opciones_columnas.vue';
import GameColumnas from './columnas_game.vue';
import Botonera from '../componentes/botonera.vue';
export default {
    props: {
        datos_editar: {
            type: Object,
            default: function () {
                return {};
            },
        },
        tipo_accion: {
            type: Number,
            default: function () {
                return 0;
            },
        },
        btn_cancelar: {
            type: Boolean,
            default: function () {
                return false;
            },
        },
        datos_tipo_juego_select: {
            type: Object,
            default: function () {
                return {};
            },
        },
    },
    mixins: [GeneralMixin],
    components: {
        CabeceraJuego,
        Opciones_columnas,
        GameColumnas,
        Botonera,
    },
    data() {
        return {
            codigo_creado: false,
            op_show: 1,
            op_cargar: false,
            datos_editar_columnas: {},
            botonera_juego:{
                cabecera:true,
                opciones:true,
                previsualizar:true,
            }
        };
    },
    created() {},
    mounted() {
        let me = this;
        me.op_cargar = false;
        me.f_iniciar();
    },
    methods: {
        f_iniciar() {
            let me = this;
            me.op_cargar = true;
            // console.log('datos_tipo_juego_select', me.datos_tipo_juego_select)
            // console.log('datos_editar columnas', me.datos_editar)
            if (me.tipo_accion == 1) { //editar juego
                me.datos_editar_columnas = me.datos_editar;
            }
            if (me.datos_editar.codigo != "" && me.datos_editar.codigo != null) {
                me.codigo_creado = true;
                // console.log('CODIGO CREADito==> ', me.codigo_creado, me.datos_editar_columnas)
            }
        },
        getCodigo(e) {
            let me = this;
            // console.log('get codigo', e);
            me.datos_editar_columnas = e;
            if (e) {
                me.codigo_creado = true;
                // me.dato_cabecera = true;
                // me.btn_cancelar = true;
                me.$emit('get_listar_juegos',e)
            }
        },
        getClicked_botonera(e) {
            let me = this;
            me.op_show = e;
            // console.log('getClicked_botonera', e);
        }
    }
};
</script>

<style scoped>
.menu-navigation-dark {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 0;
    text-align: center;
}

.menu-navigation-dark a {
    display: inline-block;
    color: #ffffff;
    background-color: #232526;
    font-size: 25px;
    font-weight: bold;
    box-shadow: 1px 3px 5px 0 rgba(0, 0, 0, 0.26);
    text-transform: uppercase;
    text-decoration: none;
    white-space: nowrap;
    border: 1px solid #161718;
    border-top: none;
    width: 136px;
    margin: 0 auto;
    padding: 10px 0;
    box-sizing: border-box;
}

.menu-navigation-dark a:hover {
    background-color: #27292a;
}

.menu-navigation-dark a:first-child {
    border-left: 1px solid #161718;
}

.menu-navigation-dark a:not(.selected) {
    box-shadow: 1px 3px 5px 0 rgba(0, 0, 0, 0.26),
        inset 1px 0 0 #323435,
        inset 0 1px 0 #282a2b,
        inset 0 -1px 0 #282a2b;
}

.menu-navigation-dark a:last-child {
    box-shadow: 1px 3px 5px 0 rgba(0, 0, 0, 0.26),
        inset 1px 0 0 #323435,
        inset -1px 0 0 #282a2b,
        inset 0 1px 0 #282a2b,
        inset 0 -1px 0 #282a2b;
}

.menu-navigation-dark a i {
    display: block;
    line-height: 1.3;
}

.menu-navigation-dark a span {
    display: block;
    font-size: 11px;
    font-weight: bold;
    line-height: 2;
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}

.menu-navigation-dark a.selected {
    background-color: #1d1e1f;
    border-bottom: 4px solid #da4a92;
    pointer-events: none;
}

.menu-navigation-dark a.selected i {
    color: #da4a92;
}

/* Make this page responsive */

.slicknav_menu {
    display: none;
}
</style>
